import { render, staticRenderFns } from "./PedidosForm.vue?vue&type=template&id=641d3672"
import script from "./PedidosForm.vue?vue&type=script&lang=js"
export * from "./PedidosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports